'use strict';

import { getNewContent } from '@jsproduct/detailsPage/colorVariants';
import { classes } from '@jspartials/class-list-utils';

// Selectors
const selector = {
  colorVariants: {
    listItem: '.js-product-color-variants__list-item'
  }
};

// Functions
const initHistoryPpd = () => {
  const currentListItemSelected = document.querySelector(
    `${selector.colorVariants.listItem}.${classes.is.selected}`
  );
  const currentProductId = currentListItemSelected
    ? currentListItemSelected.dataset.pid
    : null;
  if (currentProductId) {
    window.history.replaceState(
      {
        pid: currentProductId
      },
      document.title,
      location.href
    );
  }

  // Popstate listener
  window.addEventListener('popstate', (event) => {
    if (event.state) {
      const productId = 'pid' in event.state ? event.state.pid : null;
      const colorVariantsListItem = productId
        ? document.querySelector(
            `${selector.colorVariants.listItem}[data-pid="${productId}"]`
          )
        : null;

      if (colorVariantsListItem) {
        getNewContent(colorVariantsListItem, false);
      }
    }
  });
};

// Prevent anchor event on variation change not to reload the page
const preventAnchorEvent = () => {
  const anchors = document.querySelectorAll(selector.colorVariants.listItem);

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
    });
  });
};

preventAnchorEvent();

const updateHistory = (object) => {
  const state = 'state' in object ? object.state : {};
  const title = 'title' in object ? object.title : '';
  const url = 'url' in object ? object.url : '';

  history.pushState(state, title, url);
};

export { initHistoryPpd, updateHistory };
